import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Paper, Typography } from '@material-ui/core';
import preinformeStyles from './preinformeStyles';

/**
 * Panel oscuro de solo lectura "Metas sugeridas a 12 semanas": una celda por
 * meta con su etiqueta legible y su valor tal cual llega del backend. No
 * renderiza nada (ni el título) cuando `metas` está vacío.
 */
const MetasPanel = ({ metas }) => {
    const classes = preinformeStyles();

    if (!metas || metas.length === 0) {
        return null;
    }

    return (
        <Paper className={classes.metasPanel} elevation={0}>
            <Typography variant="h6" component="h2" className={classes.metasTitulo}>
                Metas sugeridas a 12 semanas
            </Typography>
            <Grid container spacing={2}>
                {metas.map((meta) => (
                    <Grid item xs={12} sm={6} md={4} key={meta.clave}>
                        <div className={classes.metaItem}>
                            <Typography component="span" className={classes.metaLabelPanel}>
                                {meta.etiqueta}
                            </Typography>
                            <Typography component="p" className={classes.metaValor}>
                                {meta.valor}
                            </Typography>
                        </div>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    );
};

MetasPanel.propTypes = {
    metas: PropTypes.arrayOf(PropTypes.shape({
        clave: PropTypes.string,
        etiqueta: PropTypes.string,
        valor: PropTypes.string,
    })),
};

MetasPanel.defaultProps = {
    metas: [],
};

export default MetasPanel;
